import { render } from "./App.vue?vue&type=template&id=6ac13754"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6ac13754&lang=scss"

import exportComponent from "/Users/liuhaifeng/Desktop/我的文件/双湖/双湖官网/官网/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__